const BASE = 'https://internal.invalid'

/**
 * Ruta interna segura para navegar con el router a partir de un dato externo (p. ej. el
 * `path` de un push de Comunicaciones). Solo acepta rutas del propio sitio: empiezan por
 * `/`, no por `//` ni `/\` (que el navegador trata como otro dominio), sin caracteres de
 * control. Cualquier otra cosa (URL absoluta, `javascript:`…) → `null`.
 */
export function safeInternalPath(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const path = value.trim()
  if (!path.startsWith('/') || path.startsWith('//') || path.startsWith('/\\')) return null
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(path)) return null
  try {
    const url = new URL(path, BASE)
    if (url.origin !== BASE) return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}
